import React from "react";
import AtomicModelCanvas from "../core/AtomicModelCanvas";
import useCustomCanvas from "core/hooks/useCustomCanvas";
import { CanvasContainer } from "./shared";

const AtomicModel = ({ defaultSizeSetting, selectedNuclide }) => {
  const ref = React.useRef();

  const [atomicModelCanvas, size] = useCustomCanvas(defaultSizeSetting, () => ({
    ref,
    myCanvasInstance: new AtomicModelCanvas({
      ctx: ref.current.getContext("2d"),
    }),
    registerCavansEvents: false,
  }));

  React.useEffect(() => {
    atomicModelCanvas?.setTarget(selectedNuclide);
  }, [selectedNuclide, atomicModelCanvas]);

  return (
    <CanvasContainer width={size.width}>
      <canvas ref={ref} />
    </CanvasContainer>
  );
};

export default React.memo(AtomicModel);
